<div style="display: flex; align-items: center; justify-content: space-between;">
    <div>
        <h4> {{'Percentage Worn' | translate | async}}</h4>
    </div>
    <div style="text-align: right; cursor: pointer;">
        <i class="material-icons __close-button" (click)="close()" matTooltip="Close">close</i>
    </div>
</div>

<div>
    <div mat-dialog-content class="settings-box">
        <mat-checkbox [checked]="selectedPercentage === 75" (change)="selectPercentage(75)">
            75%
        </mat-checkbox>

        <mat-checkbox [checked]="selectedPercentage === 80" (change)="selectPercentage(80)">
            80%
        </mat-checkbox>

        <mat-checkbox [checked]="selectedPercentage === 85" (change)="selectPercentage(85)">
            85%
        </mat-checkbox>

        <mat-checkbox [checked]="selectedPercentage === 90" (change)="selectPercentage(90)">
            90%
        </mat-checkbox>
    </div>
    <div mat-dialog-actions style="float: right;">
        <button mat-button (click)="close()">{{'Cancel' | translate | async}}</button>
        <button mat-raised-button color="warn" (click)="save()">{{'Save' | translate | async}}</button>
    </div>
</div>